import _DialogContent from "@mui/material/DialogContent";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import _Dialog2 from "@mui/material/Dialog";
import _Button2 from "@mui/material/Button";
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import BttfFAQ from '../event-details/bttf-faq';
import CustomPointsRules from '../event-details/custom-points-rules';
export function ChallengeCardProgressionDescription({
  Button: _Button,
  Dialog: _Dialog,
  geogroup,
  challenge,
  disabled
}) {
  const [dialogOpen, openDialog] = useState(false);
  const {
    t
  } = useTranslation();
  const isTerritoryLeaderboard = geogroup?.type === 'city';
  const title = t(isTerritoryLeaderboard ? 'commons.challenges.explanations_dialog.territory_title' : 'commons.challenges.explanations_dialog.title');
  const Button = _Button || _Button2;
  const Dialog = _Dialog || _Dialog2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: disabled,
    onClick: () => openDialog(true),
    size: "small",
    sx: {
      fontSize: '0.9rem',
      lineHeight: 1.15
    },
    variant: "text"
  }, title)), /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => openDialog(false),
    open: dialogOpen
  }, /*#__PURE__*/React.createElement(_DialogContent, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.25rem",
    fontWeight: 600
  }, title), isTerritoryLeaderboard ? /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(_Typography, {
    component: "ul",
    sx: {
      m: 0,
      pl: 3
    },
    variant: "body2"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_official_members",
    values: {
      geogroupTitle: geogroup.title
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_join_date"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_geographical_limit"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_verification"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_gpx_import"
  }))), /*#__PURE__*/React.createElement(_Typography, {
    marginTop: 2,
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.territory_note"
  }))) : /*#__PURE__*/React.createElement(_Typography, {
    component: "ul",
    variant: "body2"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.city_community",
    values: {
      geogroupTitle: geogroup?.title
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.join_date"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.too_fast"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.gpx_import"
  }))), challenge?.type === 'bttf' && /*#__PURE__*/React.createElement(BttfFAQ, {
    showBttfSite: false
  }), challenge?.type === 'custom' && challenge.metricsWeights && /*#__PURE__*/React.createElement(CustomPointsRules, {
    metricsWeights: challenge.metricsWeights
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => openDialog(false),
    variant: "contained"
  }, t('commons.actions.understood')))))));
}